// extracted by mini-css-extract-plugin
export default {"frequencyPlans":"styles_frequencyPlans__m0qOP"};